export default __webpack_public_path__ + "assets/4f8a94d01d790564fb64a165f5c62e4e.svg";